import { ChatData } from "../../Chat/ChatData";
import { ChatMessageData } from "../../Chat/ChatMessageData";
import { CollectionData } from "../../collections/CollectionData";
import { CompanyData } from "../../Company/CompanyData";
import { CompanyInvoiceReceiverData } from "../../Company/CompanyInvoiceReceiverData";
import { ContractorGroupData } from "../../ContractorGroup/ContractorGroupData";
import { DeviationCostData } from "../../Deviation/DeviationCostData";
import { DeviationData } from "../../Deviation/DeviationData";
import { DeviationUpdateData } from "../../Deviation/DeviationUpdateData";
import { SubtaskData } from "../../Deviation/SubtaskData";
import { EventData } from "../../Event/EventData";
import { PostData } from "../../Post/PostData";
import BookingData from "../../Property/Booking/BookingData";
import { BookingDataHelper } from "../../Property/Booking/BookingDataHelper";
import BookingUnitData from "../../Property/Booking/BookingUnitData";
import { PropertyCollectionData } from "../../Property/Collections/PropertyCollectionData";
import { PropertyCollectionItemData } from "../../Property/Collections/PropertyCollectionItemData";
import { MemberData } from "../../Property/MemberData";
import { PropertyData } from "../../Property/PropertyData";
import { UnitData } from "../../Property/Units/UnitData";
import { RoutineData } from "../../Routines/RoutineData";
import { NotificationData } from "../../User/Notifications/NotificationData";
import { NotificationDataHelper } from "../../User/Notifications/NotificationDataHelper";
import { UserData } from "../../User/UserData";
import { UserDeviceData } from "../../User/UserDeviceData";
import { ChatDataHelper } from "../DataObjectHelpers/Chat/ChatDataHelper";
import { ChatMessageDataHelper } from "../DataObjectHelpers/Chat/ChatMessageDataHelper";
import { CompanyDataHelper } from "../DataObjectHelpers/Company/CompanyDataHelper";
import { ContractorGroupDataHelper } from "../DataObjectHelpers/Contractor/ContractorGroupDataHelper";
import { DeviationCostDataHelper } from "../DataObjectHelpers/Deviation/DeviationCostDataHelper";
import { DeviationDataHelper } from "../DataObjectHelpers/Deviation/DeviationDataHelper";
import { DeviationSubtaskDataHelper } from "../DataObjectHelpers/Deviation/DeviationSubtaskDataHelper";
import { DeviationTimeEntryDataHelper } from "../DataObjectHelpers/Deviation/DeviationTimeEntryDataHelper";
import { DeviationUpdateDataHelper } from "../DataObjectHelpers/Deviation/DeviationUpdateDataHelper";
import { IRawDeviationHelper } from "../DataObjectHelpers/Deviation/IRawDeviationHelper";
import { ITaskHelper } from "../DataObjectHelpers/Deviation/ITaskHelper";
import { EmptyDataObjectHelper } from "../DataObjectHelpers/EmptyDataObjectHelper";
import { EventDataHelper } from "../DataObjectHelpers/Event/EventDataHelper";
import { FileDocumentDataHelper } from "../DataObjectHelpers/FileDocumentDataHelper/FileDocumentDataHelper";
import { GlobalFileDataHelper } from "../DataObjectHelpers/FileDocumentDataHelper/GlobalFileDataHelper";
import { PropertyFileDataHelper } from "../DataObjectHelpers/FileDocumentDataHelper/PropertyFileDataHelper";
import { InvoiceReceiverDataHelper } from "../DataObjectHelpers/InvoiceReceiverDataHelper";
import { LandaxIncidentDataHelper } from "../DataObjectHelpers/Landax/LandaxIncidentDataHelper";
import { LandaxTaskDataHelper } from "../DataObjectHelpers/Landax/LandaxTaskDataHelper";
import { LifeAtWorkCommentHelper } from "../DataObjectHelpers/LifeAtWork/LifeAtWorkCommentHelper";
import { LifeAtWorkTicketHelper } from "../DataObjectHelpers/LifeAtWork/LifeAtWorkTicketHelper";
import { PostDataHelper } from "../DataObjectHelpers/Post/PostDataHelper";
import { BookingUnitDataHelper } from "../DataObjectHelpers/Property/BookingUnitDataHelper";
import { CollectionItemDataHelper, GenericCollectionType } from "../DataObjectHelpers/Property/CollectionItemDataHelper";
import { GlobalCollectionItemDataHelper } from "../DataObjectHelpers/Property/GlobalCollectionItemDataHelper";
import { IApiCollectionItemHelper } from "../DataObjectHelpers/Property/IApiCollectionItemHelper";
import { PropertyDataHelper } from "../DataObjectHelpers/Property/PropertyDataHelper";
import { PropertyInfoFieldGeneralDataHelper } from "../DataObjectHelpers/Property/PropertyInfoFieldGeneralDataHelper";
import { PropertyMemberDataHelper } from "../DataObjectHelpers/Property/PropertyMemberDataHelper";
import { UnitDataHelper } from "../DataObjectHelpers/Property/UnitDataHelper";
import { V2CollectionItemDataHelper } from "../DataObjectHelpers/Property/V2CollectionItemDataHelper";
import { ReadAccessDataHelper } from "../DataObjectHelpers/ReadAccessDataHelper";
import { RoutineDataHelper } from "../DataObjectHelpers/Routine/RoutineDataHelper";
import { SensorDataHelper } from "../DataObjectHelpers/SensorDataHelper";
import { TrashcanItemDataHelper } from "../DataObjectHelpers/TrashcanItemDataHelper/TrashcanItemDataHelper";
import { PushNotificationDataHelper } from "../DataObjectHelpers/User/PushNotificationDataHelper";
import { UserDataHelper } from "../DataObjectHelpers/User/UserDataHelper";
import { UserDeviceDataHelper } from "../DataObjectHelpers/User/UserDeviceDataHelper";
import { WorkflowDataHelper } from "../DataObjectHelpers/Workflow/WorkflowDataHelper";
import { FileDocumentData } from "../FileDocumentData";
import { FirebaseData } from "../FirebaseData";
import { DataObjectHelper } from "./DataObjectHelper";

export class DataObjectHelpers {
  static empty = new EmptyDataObjectHelper();
  static readAccess = new ReadAccessDataHelper();
  static fileDocument = new FileDocumentDataHelper();
  static propertyFile = new PropertyFileDataHelper();
  static globalFile = new GlobalFileDataHelper();
  static user = new UserDataHelper();
  static pushData = new PushNotificationDataHelper();
  static company = new CompanyDataHelper();
  static contractor = new ContractorGroupDataHelper();
  static routine = new RoutineDataHelper();
  static property = new PropertyDataHelper();
  static propertyInfoField = new PropertyInfoFieldGeneralDataHelper();
  static propertyMembers = new PropertyMemberDataHelper();
  static unit = new UnitDataHelper();
  private static globalCollectionItems: GlobalCollectionItemDataHelper[] = [];
  private static collectionItems: CollectionItemDataHelper[] = [];
  private static v2CollectionItems: V2CollectionItemDataHelper[] = [];

  /**
   * @deprecated use and initialize IRawCollectionItemHelper instead
   */
  private static apiCollectionItems: IApiCollectionItemHelper[] = [];

  static deviation = new DeviationDataHelper();
  static iRawDeviation = new IRawDeviationHelper();
  static iTask = new ITaskHelper();
  static deviationUpdate = new DeviationUpdateDataHelper();
  static deviationTask = new DeviationSubtaskDataHelper();
  static deviationCost = new DeviationCostDataHelper();
  static deviationTimeEntry = new DeviationTimeEntryDataHelper();
  static booking = new BookingDataHelper();
  static bookingUnit = new BookingUnitDataHelper();
  static workflows = new WorkflowDataHelper();
  static invoiceReceiever = new InvoiceReceiverDataHelper();
  static event = new EventDataHelper();
  static post = new PostDataHelper();
  static notification = new NotificationDataHelper();
  static userDevice = new UserDeviceDataHelper();
  static chat = new ChatDataHelper();
  static chatMessage = new ChatMessageDataHelper();
  static sensorData = new SensorDataHelper();
  static landax_tasks = new LandaxTaskDataHelper();
  static landax_incident = new LandaxIncidentDataHelper();
  static lifeatwork_comment = new LifeAtWorkCommentHelper();
  static lifeatwork_ticket = new LifeAtWorkTicketHelper();
  static trashcan_item = new TrashcanItemDataHelper();

  static allDataObjectHelpers: DataObjectHelper<any>[] = [
    DataObjectHelpers.empty,
    DataObjectHelpers.readAccess,
    DataObjectHelpers.fileDocument,
    DataObjectHelpers.user,
    DataObjectHelpers.pushData,
    DataObjectHelpers.company,
    DataObjectHelpers.contractor,
    DataObjectHelpers.routine,
    DataObjectHelpers.property,
    DataObjectHelpers.propertyInfoField,
    DataObjectHelpers.propertyMembers,
    DataObjectHelpers.unit,
    DataObjectHelpers.getCollectionItemHelper(undefined),
    DataObjectHelpers.deviation,
    DataObjectHelpers.deviationUpdate,
    DataObjectHelpers.deviationTask,
    DataObjectHelpers.deviationCost,
    DataObjectHelpers.deviationTimeEntry,
    DataObjectHelpers.bookingUnit,
    DataObjectHelpers.workflows,
    DataObjectHelpers.sensorData,
    DataObjectHelpers.landax_tasks,
    DataObjectHelpers.landax_incident,
    DataObjectHelpers.invoiceReceiever,
  ];

  static getAllDataObjectHelpers(): DataObjectHelper<any>[] {
    return [...this.allDataObjectHelpers, ...this.collectionItems, ...this.globalCollectionItems];
  }

  static getHelper(data: FirebaseData | FirebaseData[]): DataObjectHelper<any> | undefined {
    const type = Array.isArray(data) ? (data.length > 0 ? data[0] : undefined) : data;

    // ReadAccess
    if (type instanceof FileDocumentData) return this.fileDocument;
    if (type instanceof UserData) return this.user;
    if (type instanceof PushNotificationDataHelper) return this.pushData;
    if (type instanceof CompanyData) return this.company;
    if (type instanceof ContractorGroupData) return this.contractor;
    if (type instanceof RoutineData) return this.routine;
    if (type instanceof PropertyData) return this.property;
    // InfoField
    if (type instanceof MemberData) return this.propertyMembers;
    if (type instanceof UnitData) return this.unit;
    if (type instanceof PropertyCollectionItemData) {
      return type.parent instanceof PropertyCollectionData ? this.getCollectionItemHelper(type.parent) : this.getCollectionItemHelper(undefined);
    }
    if (type instanceof DeviationData) return this.deviation;
    if (type instanceof DeviationUpdateData) return this.deviationUpdate;
    if (type instanceof SubtaskData) return this.deviationTask;
    if (type instanceof DeviationCostData) return this.deviationCost;
    if (type instanceof DeviationCostData) return this.deviationTimeEntry;
    if (type instanceof BookingUnitData) return this.bookingUnit;
    if (type instanceof BookingData) return this.booking;
    if (type instanceof EventData) return this.event;
    if (type instanceof PostData) return this.post;
    if (type instanceof NotificationData) return this.notification;
    if (type instanceof UserDeviceData) return this.userDevice;
    if (type instanceof ChatData) return this.chat;
    if (type instanceof ChatMessageData) return this.chatMessage;

    if (type instanceof CompanyInvoiceReceiverData) return this.invoiceReceiever;

    // itask, irawdeviation - Don't think they are needed

    // Sensor
    // Landax Task
    // Landax Incident

    return this.empty;
  }

  static getCollectionItemHelper(collection: GenericCollectionType | undefined): CollectionItemDataHelper {
    for (const item of this.collectionItems) {
      if (item.getCollection() === collection) {
        return item;
      }
    }
    const item = new CollectionItemDataHelper(collection);
    this.collectionItems.push(item);
    return item;
  }

  /**
   * @deprecated use and initialize IRawCollectionItemHelper instead
   */
  static getApiCollectionItemHelper(collection: GenericCollectionType): IApiCollectionItemHelper {
    for (const item of this.apiCollectionItems) {
      if (item.collection === collection) {
        return item;
      }
    }
    const item = new IApiCollectionItemHelper(collection);
    this.apiCollectionItems.push(item);
    return item;
  }

  static getV2CollectionItemHelper(collection: CollectionData): V2CollectionItemDataHelper {
    for (const item of this.v2CollectionItems) {
      if (item.collection === collection) {
        return item;
      }
    }
    const item = new V2CollectionItemDataHelper(collection);
    this.v2CollectionItems.push(item);
    return item;
  }

  static getAllCollectionItemHelpers(): CollectionItemDataHelper[] {
    return this.collectionItems.filter((c) => c.getCollection() !== undefined);
  }

  static getAllGlobalCollectionItemHelpers(): GlobalCollectionItemDataHelper[] {
    return this.globalCollectionItems;
  }

  static getGlobalCollectionItemHelper(collectionID: string) {
    for (const item of this.globalCollectionItems) {
      if (item.collectionID === collectionID) {
        return item;
      }
    }
    const item = new GlobalCollectionItemDataHelper(collectionID);
    this.globalCollectionItems.push(item);
    return item;
  }
}
